import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import TesztlapokEditService from 'app/admin/tesztlapok/service/TesztlapokEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import ExamImageSheetCorrectionField from 'app/admin/examImage/sheetCorrection/ExamImageSheetCorrectionField';
import nBossConnection from 'modules/base/service/nBossConnection';

const config = {
	key: 'tesztlapokEditForm',
	text: 'Tesztlapok',
	textKey: 'tesztlapok',
	service: TesztlapokEditService,
	icon: 'person',
	hideSaveButton: true,
	fields: [
		{
			key: 'elokeszitettPath',
			text: 'Előkészített',
			textKey: 'elokeszitettPath',
			component: ExamImageSheetCorrectionField,
			imageUrl: `${nBossConnection.baseUrl}fmBrowserTableControl/getFileByPath?path=`
		}
	]
};

function TesztlapokEditForm() {
	return <EditFormPage config={config} />;
}

export default TesztlapokEditForm;
